<div class="notification-container--overlay" (click)="closeNotification()"></div>
<div class="notification-container">
  <div class="notification-container--header">
    <sc-icon icon="arrow-left-big" class="pointer" (click)="closeNotification()"></sc-icon>
    <span>Notificaciones</span>
  </div>

  <div class="notification-container--content">
    <sc-tab [items]="items" (selectedTabToEmit)="selectTab($event)">
    </sc-tab>
    <div class="notification-container--content--loading" *ngIf="isLoading">
      <sc-icon icon="loading" size="2"></sc-icon>
    </div>
    <div class="notification-container--content--noresult" *ngIf="!isLoading && notifications.length === 0">
      <img src="assets/images/home/no-notificaciones.svg" class="" alt="">
      <p>No hay notificaciones en este momento</p>
    </div>
    <ng-container *ngFor="let notification of notifications">
      <div class="notification-container--content--item" [ngClass]="{'seen': notification.isSeen}"
        [ngStyle]="{'border-top-color': '#' + notification.notificationType.color}">
        <span
          class="notification-container--content--item__date">{{ notification.receivedDate | date:'dd/MM/yy' }}<br></span>
        <span class="notification-container--content--item__title">{{ getTitleCard(notification) }}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="getTransitoryPaymentRequestCount(notification)">Rechazos Transitorios:
          {{ getTransitoryPaymentRequestCount(notification)}}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="getDefinitivePaymentRequestCount(notification)">Rechazos Definitivos:
          {{ getDefinitivePaymentRequestCount(notification)}}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="getReason(notification)">{{ getReason(notification)}}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="notification.branch">{{ notification.branch | scBranchDescription | titlecase}}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="notification.policyNumber || notification.jobNumber">{{ notification.policyNumber || notification.jobNumber}}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="notification.insuredName ">{{ notification.insuredName | titlecase}}<br></span>
        <span class="notification-container--content--item__description"
          *ngIf="notification.notificationType.notificationTypeActions.length > 0">
          <sc-notification-type-action [notificationTypeActions]="getActionsCard(notification)"
            [notificationId]="notification.id" (onActionTriggered)="readAndClose(notification)">
          </sc-notification-type-action>
        </span>

        <span class="notification-container--content--item__action">

          <a (click)="actionNotificationClick(notification)" *ngIf="notification.isRead">
            <sc-icon icon="eye" size="1"></sc-icon>
          </a>
          <a (click)="actionNotificationClick(notification)" *ngIf="!notification.isRead">
            <sc-icon icon="eye-hidden" size="1"></sc-icon>
          </a>
        </span>

      </div>
    </ng-container>

  </div>

</div>